import { LabelPrintData } from "src/apis/labelApi";
import { formatDate } from "src/utils/string/stringUtil";

export interface WMS1141_R01StoreData {
    WMS1141_R01DetailList: any[];
    editWMS1141_R01: any;
}

const formatQty = (qty: number | undefined, unit: string): string => {
    if (!qty && qty !== 0) return '';
    return `${qty.toLocaleString()}${unit || 'EA'}`;
};

const WMS1141_R01_buildLabelDataFromDetail = (
    detail: any,
    header: any
): LabelPrintData => {
    if (!detail) throw new Error('라벨 대상 상세 데이터가 없습니다.');
    if (!header) throw new Error('입고 정보를 찾을 수 없습니다');

    const transportDate = header.transportDt
        ? formatDate(new Date(header.transportDt))
        : formatDate(new Date());

    return {
        lotNo: detail.lotNo || '',
        itemCd: detail.itemCd || '',
        itemNm: detail.itemNm || '',
        itemSpec: detail.itemSpec || '',
        transportDate,
        itemAccountNm: detail.itemAccountNm || header.inoutMethod || '',
        storageLocation: detail.locationNm || detail.locationCd || '-',
        qty: formatQty(detail.qty, detail.unit || 'EA'),
        customer: header.customNm || '',
        customerItemCd: detail.customerItemCd || detail.itemCd || '',
        labelType: '[자재입고]',
    };
};

export const WMS1141_R01_buildLabelData = (
    lotNo: string,
    itemCd: string,
    store: WMS1141_R01StoreData
): LabelPrintData => {
    const { WMS1141_R01DetailList, editWMS1141_R01 } = store;
    const detail = WMS1141_R01DetailList.find((d: any) =>
        (lotNo && d.lotNo === lotNo) || d.itemCd === itemCd
    );
    if (!detail) throw new Error(`Detail를 찾을 수 없습니다: lotNo=${lotNo}, itemCd=${itemCd}`);

    return WMS1141_R01_buildLabelDataFromDetail(detail, editWMS1141_R01);
};

export const WMS1141_R01_buildLabelDataByValueIndex = (
    valueIndex: number,
    itemCd: string,
    store: WMS1141_R01StoreData
): LabelPrintData | null => {
    const { WMS1141_R01DetailList } = store;
    const detail = WMS1141_R01DetailList.find((d: any) => d.valueIndex === valueIndex);

    if (!detail) {
        console.warn(`Detail를 찾을 수 없습니다: valueIndex=${valueIndex}, itemCd=${itemCd}`);
        return null;
    }

    try {
        return WMS1141_R01_buildLabelDataFromDetail(detail, store.editWMS1141_R01);
    } catch (error) {
        console.error('라벨 데이터 생성 실패:', error);
        return null;
    }
};

export const WMS1141_R01_extractUnprintedLabelData = (
    store: WMS1141_R01StoreData,
    deletedDetailList: string[] = []
): LabelPrintData[] => {
    const { WMS1141_R01DetailList } = store;
    const unprintedLabelData: LabelPrintData[] = [];
    const deletedSet = new Set(deletedDetailList);

    WMS1141_R01DetailList.forEach((detail: any) => {
        const valueIndex = detail.valueIndex?.toString() ?? '';
        if (
            !deletedSet.has(valueIndex) &&
            !detail.printed &&
            detail.qty > 0
        ) {
            try {
                unprintedLabelData.push(
                    WMS1141_R01_buildLabelDataFromDetail(detail, store.editWMS1141_R01)
                );
            } catch (error) {
                console.error(`라벨 데이터 구성 실패: ${detail.lotNo}`, error);
            }
        }
    });

    return unprintedLabelData;
};
